const API_BASE_URL = 'https://panel.supplebakes.com/api';

export const api = {
  get: async (endpoint, params = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    
    // Check if running in Cordova and the plugin is available
    if (window.cordova && window.cordova.plugin && window.cordova.plugin.http) {
      try {
        console.log(`🔌 Native HTTP GET: ${url}`);
        const response = await new Promise((resolve, reject) => {
          window.cordova.plugin.http.get(url, params, {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }, (response) => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
        });
        
        // Native HTTP returns data as a string, need to parse it
        try {
          return JSON.parse(response.data);
        } catch (e) {
          console.error('❌ JSON Parse Error:', e);
          throw new Error('Failed to parse API response: ' + response.data);
        }
      } catch (error) {
        console.error('❌ Native HTTP Error:', error);
        // Extract useful error message from plugin error object
        const errorMsg = error.error || error.message || JSON.stringify(error);
        throw new Error(`Native HTTP Error: ${error.status || 'Unknown'} - ${errorMsg}`);
      }
    } else {
      // Fallback to fetch for browser/development
      try {
        console.log(`🌐 Fetch GET: ${url}`);
        // Convert params to query string for fetch
        const queryString = Object.keys(params).length 
          ? '?' + new URLSearchParams(params).toString() 
          : '';
          
        const response = await fetch(`${url}${queryString}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          cache: 'no-cache'
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return await response.json();
      } catch (error) {
        console.error('❌ Fetch Error:', error);
        throw error;
      }
    }
  }
};
